import React from 'react'
import { Route } from 'react-router-dom'
import { t } from 'ttag'

import { NavigatorConnection } from '@h2/features/dashboard/account/panels/navigatorConnection'
import { Container } from '@h2/components/layout/container'

import EducatorReferral from './EducatorReferral'
import EducatorAccountRegistrationAcceptance from './EducatorAccountRegistrationAcceptance'
import EducatorCorner from './EducatorCorner'

import RequireSignIn from '../../components/RequireSignIn'

function EducatorRoutes(props) {
  return (
    <>
      <Route path="/refereducator" exact>
        <RequireSignIn name={t`Educator Referral`}>
          <EducatorReferral {...props} />
        </RequireSignIn>
      </Route>
      <Route path="/request/code/:navigatorCode">
        <Container>
          <NavigatorConnection />
        </Container>
      </Route>
      <Route path="/requestmanagement/confirm/:confirmationCode">
        <EducatorAccountRegistrationAcceptance />
      </Route>
      <Route path="/educators/:modalId?/:modalSubId?" component={EducatorCorner} />
    </>
  )
}

EducatorRoutes.propTypes = {}
EducatorRoutes.defaultProps = {}

export default EducatorRoutes
